import axios from "axios";
import { API_ENDPOINTS } from "./apiEndpoints";
import type { GroupTravelPayload } from "../utils/mapFormDataToPayload";

export async function sendGroupTravelApplication(
  payload: GroupTravelPayload
): Promise<string> {
  try {
    const response = await axios.post<string>(
      API_ENDPOINTS.sendGroupTravelApplication,
      payload
    );

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("[GroupTravel API failed]", {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        response: error.response?.data,
        code: error.code,
        message: error.message,
      });
    } else {
      console.error("[GroupTravel API failed]", error);
    }

    throw error;
  }
}
